// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"5d1146bc","607":"0090f166"}[chunkId] + ".chunk.js";
};